import { publicFetch, PublicApiError } from "../../api/public-fetch";

import type { AssessmentStatePayload } from "./types";

// Re-export so existing `import { AssessmentApiError }` sites keep compiling.
export { PublicApiError };

export async function fetchAssessment(token: string): Promise<AssessmentStatePayload> {
  return publicFetch<AssessmentStatePayload>(`/assessment/love-receive/${token}`);
}

export async function submitAssessment(
  token: string,
  answers: number[],
): Promise<AssessmentStatePayload> {
  return publicFetch<AssessmentStatePayload>(`/assessment/love-receive/${token}/response`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ answers }),
  });
}

// Re-export types from ./types so existing callers that import from `../api/client`
// continue to work without churn. New code should prefer importing types from
// `../api/types` directly to keep the runtime and type layers separable.
export type {
  AssessmentState,
  AssessmentStatePayload,
  InsightHighlight,
  Insights,
  LanguageCopy,
  LanguageKey,
  Question,
} from "./types";
